import { useScrollReveal } from '@/hooks/useScrollReveal';

const CTASection = () => {
  const { ref, visible } = useScrollReveal(0.1);

  return (
    <section className="py-20 relative overflow-hidden">
      <div
        className="absolute inset-0"
        style={{
          backgroundImage: `url(https://public.readdy.ai/ai/img_res/af60e11db655e88b33672928c748b1dc.jpg)`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      />
      <div className="absolute inset-0 bg-slate-900/85" />

      {/* Animated background particles */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        {[...Array(6)].map((_, i) => (
          <div
            key={i}
            className="absolute rounded-full bg-orange-500/10 animate-pulse"
            style={{
              width: `${80 + i * 40}px`,
              height: `${80 + i * 40}px`,
              left: `${10 + i * 15}%`,
              top: `${20 + (i % 3) * 25}%`,
              animationDelay: `${i * 0.5}s`,
              animationDuration: `${3 + i * 0.5}s`,
            }}
          />
        ))}
      </div>

      <div
        ref={ref}
        className={`relative z-10 max-w-4xl mx-auto px-4 md:px-6 text-center transition-all duration-1000 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'}`}
      >
        <span className="inline-block bg-orange-500/20 text-orange-400 text-xs font-semibold px-3 py-1 rounded-full mb-4 uppercase tracking-wider border border-orange-500/30">
          Hızlı Destek
        </span>
        <h2 className="text-3xl md:text-5xl font-extrabold text-white mb-5 leading-tight">
          Cihazınızda Sorun mu Var?
        </h2>
        <p className="text-slate-300 text-base md:text-lg mb-8 max-w-2xl mx-auto leading-relaxed">
          Uzman teknisyen ekibimiz 7/24 hizmetinizde. Hemen iletişime geçin, en kısa sürede çözüm üretelim.
        </p>
        <div className={`flex flex-col sm:flex-row gap-4 justify-center transition-all duration-700 delay-300 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}>
          <a
            href="/iletisim"
            className="bg-orange-500 hover:bg-orange-600 hover:scale-105 text-white px-8 py-3.5 rounded-lg font-semibold transition-all duration-200 flex items-center justify-center gap-2 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-phone-line"></i>
            Hemen Ara
          </a>
          <a
            href="/ikinci-el"
            className="border border-white/30 hover:border-white hover:bg-white/10 hover:scale-105 text-white px-8 py-3.5 rounded-lg font-semibold transition-all duration-200 flex items-center justify-center gap-2 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-shopping-bag-line"></i>
            İkinci El Ürünleri İncele
          </a>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
